"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorToRGBA = void 0;
const chromatism_1 = require("chromatism");
const getColorToRGBA = (color, opacity = 1) => {
    const { r, g, b } = (0, chromatism_1.convert)(color).rgb;
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
exports.getColorToRGBA = getColorToRGBA;
